import CreateEditSiteViewModel from "../../Site/ViewModels/CreateEditSiteViewModel";

export default class CreateEditOrganisationViewModel {
    public id: string = '';
    public organisationName: string = '';
    public renewalDate: Date = new Date();
    public expiryDate: Date = new Date();
    public tempExpiryDate: Date | null = null;
    public invoicePayee: string = '';
    public locationId: string = '';
    public licenseTypeId: string = '';
    public invoicePayPeriodId: string = '';
    public invoicePayMethodId: string = '';
    public invoiceNoticeId: string = '';
    public estimateNoticeId: string = '';
    public sites: CreateEditSiteViewModel[] = [];
    public administratorSiteId: string = '';

    public memberNumber: string = '';
    public totalMembers: string = '';
    public totalManagers: string = '';
    public archived: boolean = false;

}

